/* eslint-disable no-return-assign */
import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import PropTypes from 'prop-types';

import Koin from './Koin';

function AnimatedKoin({ position, rotate }) {
  const koin = useRef();
  useFrame((_state, delta) => (koin.current.rotation.y += delta * 2));
  return (
    <mesh ref={koin} position={position} rotate={rotate}>
      <Koin />
    </mesh>
  );
}
AnimatedKoin.propTypes = {
  position: PropTypes.arrayOf(PropTypes.number).isRequired,
  rotate: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default AnimatedKoin;
